import { CollapseButton } from 'components/SideNav/CollapseButton/CollapseButton'
import type { CSSProperties } from 'react'
import type { TPanelPlacement, TSelectedTab } from 'stores/detailsPanelStore/detailsPanelStore'
import { closeDetailsPanel, detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import type { TabPane } from '../DetailPanel'
import { getPanelStateAfterTabClick } from '../getPanelStateAfterTabClick'
import { TabSelectionButton } from './TabSelectionButton'

const handleTabClick = (clickedTab: TSelectedTab) => {
  detailsPanelStore.setState((s) => ({
    ...s,
    ...getPanelStateAfterTabClick({ isPanelOpen: s.isPanelOpen, selectedTab: s.selectedTab, clickedTab }),
  }))
}

export const PanelTabs = ({
  tabs,
  placement,
  isWideScreen,
  isOpen,
  position,
  transition,
}: {
  tabs: TabPane[]
  placement: TPanelPlacement
  isWideScreen: boolean
  isOpen: boolean
  position: { top: number; left: number; buttonWidth: number; buttonHeight: number }
  transition: CSSProperties['transition']
}) => {
  const selectedTab = detailsPanelStore.useSelector((s) => s.selectedTab)

  return (
    <>
      {isOpen && !isWideScreen && (
        <div
          css={{ position: 'fixed', left: 0, top: 0, overflow: 'hidden' }}
          style={{
            width: placement === 'right' ? position.left : '100%',
            height: placement === 'bottom' ? position.top : '100%',
          }}
          onClick={closeDetailsPanel}
        />
      )}
      <div
        css={{
          position: 'fixed',
          zIndex: 2,
          display: 'flex',
          flexDirection: placement === 'right' ? 'column' : 'row',
        }}
        style={{ top: position.top, left: position.left, transition }}
      >
        {isWideScreen && placement === 'right' && (
          <CollapseButton
            menuCollapsed={!isOpen}
            onToggleExpand={closeDetailsPanel}
            otherStyleProps={{
              position: 'absolute',
              top: -5,
              left: -40,
            }}
          />
        )}
        {tabs.map(({ key, label, icon }) => (
          <TabSelectionButton
            key={key}
            width={position.buttonWidth}
            height={position.buttonHeight}
            isLarge={isWideScreen && placement === 'right'}
            handleClick={handleTabClick}
            label={label}
            value={key}
            icon={icon}
            selected={isOpen && selectedTab === key}
            placement={placement}
          />
        ))}
      </div>
    </>
  )
}
